
import { Action, Component, Getter, State, Vue } from 'nuxt-property-decorator';
import { ThemeName, TSiteConfigState } from '~/store/types';
import { IMyTheaterState } from '../../store/myTheater/types';
import { ITheaterScreenNode } from '~/types/my-theater';

@Component({
  meta: {
    theme: ThemeName.DARK,
  },
})
export default class Collection extends Vue {
  @Getter('siteConfig')
  readonly siteConfigState!: TSiteConfigState;

  @Action('getScreenNodes', { namespace: 'myTheater' })
  private getScreenNodes!: () => void;

  @State((myTheater: IMyTheaterState) => myTheater.screenNodes, {
    namespace: 'myTheater',
  })
  readonly screenNodes!: ITheaterScreenNode[];

  created() {
    this.getScreenNodes();
  }
}
